export const en = {
    titreOnglet: "Transactions | Desjardins"
};
